/**
 * Temp enum for js files to use Industry Values
 */

export enum IndustryValue {
  AerospaceDefense = 'AerospaceDefense',
  Automotive = 'Automotive',
  Banking = 'Banking',
  Brokerage = 'Brokerage',
  BusinessServices = 'BusinessServices',
  Construction = 'Construction',
  Consulting = 'Consulting',
  ConsumerPackagedGoods = 'ConsumerPackagedGoods',
  ConsumerServices = 'ConsumerServices',
  DiversifiedFinancialServices = 'DiversifiedFinancialServices',
  Education = 'Education',
  Energy = 'Energy',
  FoodBeverages = 'FoodBeverages',
  Government = 'Government',
  HardwareElectronicsSemiconductors = 'HardwareElectronicsSemiconductors',
  Healthcare = 'Healthcare',
  HospitalityAttractions = 'HospitalityAttractions',
  Insurance = 'Insurance',
  InternetSocialMedia = 'InternetSocialMedia',
  InvestmentBanking = 'InvestmentBanking',
  LawFirms = 'LawFirms',
  Manufacturing = 'Manufacturing',
  Materials = 'Materials',
  Media = 'Media',
  MedicalDevicesDigitalHealth = 'MedicalDevicesDigitalHealth',
  NA = 'NA',
  NonProfit = 'NonProfit',
  Other = 'Other',
  PharmaBiotech = 'PharmaBiotech',
  ProfessionalServices = 'ProfessionalServices',
  RealEstate = 'RealEstate',
  Retail = 'Retail',
  Software = 'Software',
  Telecom = 'Telecom',
  Transportation = 'Transportation',
  Utilities = 'Utilities',
  VentureCapitalPrivateEquity = 'VentureCapitalPrivateEquity',
}

const IndustryValueLabelsForLegacyJsApiUseOnly = {
  AerospaceDefense: 'Aerospace & Defense',
  Automotive: 'Automotive',
  Banking: 'Banking',
  Brokerage: 'Brokerage',
  BusinessServices: 'Business Services',
  Construction: 'Construction',
  Consulting: 'Consulting',
  ConsumerPackagedGoods: 'Consumer Packaged Goods',
  ConsumerServices: 'Consumer Services',
  DiversifiedFinancialServices: 'Diversified Financial Services',
  Education: 'Education',
  Energy: 'Energy',
  FoodBeverages: 'Food & Beverages',
  Government: 'Government',
  HardwareElectronicsSemiconductors: 'Hardware, Electronics, & Semiconductors',
  Healthcare: 'Healthcare',
  HospitalityAttractions: 'Hospitality & Attractions',
  Insurance: 'Insurance',
  InternetSocialMedia: 'Internet & Social Media',
  InvestmentBanking: 'Investment Banking',
  LawFirms: 'Law Firms',
  Manufacturing: 'Manufacturing',
  Materials: 'Materials',
  Media: 'Media',
  MedicalDevicesDigitalHealth: 'Medical Devices & Digital Health',
  NA: 'NA',
  NonProfit: 'Non-Profit',
  Other: 'Other',
  PharmaBiotech: 'Pharma & Biotech',
  ProfessionalServices: 'Professional Services',
  RealEstate: 'Real Estate',
  Retail: 'Retail',
  Software: 'Software',
  Telecom: 'Telecom',
  Transportation: 'Transportation',
  Utilities: 'Utilities',
  VentureCapitalPrivateEquity: 'Venture Capital & Private Equity',
};

export const IndustryValueLabelsMap = new Map(
  Object.entries(IndustryValueLabelsForLegacyJsApiUseOnly)
);
